import { Box, Flex, Link as ChakraLink } from '@chakra-ui/react';
import { Link } from '@tanstack/react-router';
import { type LucideIcon } from 'lucide-react';

const SidebarItem = ({
  title,
  href,
  isSelected,
  onClick,
  isSubItem = false,
  icon: Icon,
}: {
  title: string;
  href: string;
  isSelected: boolean;
  onClick?: () => void;
  isSubItem?: boolean;
  icon?: LucideIcon;
}) => {
  return (
    <ChakraLink
      to={href}
      as={Link}
      style={{ width: '100%' }}
      onClick={onClick}
      _hover={{ textDecoration: 'none' }}
      _focusVisible={{ boxShadow: 'none' }}
    >
      <Flex
        position={'relative'}
        cursor={'pointer'}
        alignItems={'center'}
        gap={'10px'}
        paddingLeft={isSubItem ? '12px' : '14px'}
        paddingRight={'12px'}
        height={isSubItem ? '38px' : '44px'}
        fontWeight={isSelected ? 700 : isSubItem ? 500 : 600}
        fontSize={isSubItem ? '14px' : '15px'}
        color={isSelected ? 'white' : 'whiteAlpha.700'}
        bgColor={isSelected ? 'whiteAlpha.200' : 'transparent'}
        _hover={{
          bgColor: isSelected ? 'whiteAlpha.200' : 'whiteAlpha.100',
          color: 'white',
        }}
        borderRadius={'10px'}
        transition={'background-color 0.18s ease, color 0.18s ease'}
      >
        {/* Active accent bar (top-level items only; sub-items use the tree guide line) */}
        {isSelected && !isSubItem && (
          <Box
            position={'absolute'}
            left={'0'}
            top={'50%'}
            transform={'translateY(-50%)'}
            width={'3px'}
            height={'18px'}
            borderRadius={'full'}
            bgColor={'primary.300'}
          />
        )}
        {Icon && <Icon size={18} strokeWidth={isSelected ? 2.4 : 2} />}
        {title}
      </Flex>
    </ChakraLink>
  );
};

export default SidebarItem;
